function setValueRadio(state, value) {
  for (let index = 0; index < state.inputs.length; index++) {
    const input = state.inputs[index]
    if (input.value === value) {
      input.checked = true
      state.valid = true
    } else {
      input.valid = false
    }
  }
}

export default setValueRadio
